import React from 'react';
import * as Icons from './icons';

export type IconName = keyof typeof Icons;

export interface IconProps {
    height?: number;
    width?: number;
    className?: string;
}

interface IconComponentProps extends IconProps {
    iconName: IconName;
}

const icon: React.FC<IconComponentProps> = ({
    height = 24,
    width = 24,
    className = '',
    iconName,
}) => {
    const SelectedIcon = Icons[iconName] as React.FC<IconProps>;

    if (!SelectedIcon) {
        return (
            <Icons.Logo
                height={height}
                width={width}
                className="fill-primary dark:fill-secondary"
            />
        );
    }

    return <SelectedIcon height={height} width={width} className={className} />;
};

export default icon;
